'use client';

import { useEffect, useState } from 'react';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import BusinessRoundedIcon from '@mui/icons-material/BusinessRounded';
import { Button } from '@mui/material';
import NationalIdFrom from '../components/company-national-id-form';
import AuthContainer from '../components/AuthContainer';
import NoSejamInfo from '../components/NoSejamInfo';
import { useAuthStore } from '../store';
import { LoginContainerFactory } from './LoginContainerFactory';
import LogoHeader from '@/containers/auth/components/LogoHeader';
import { sendGoogleGTMEvent } from '@/utils/googleGTM';
import { useLoginDisplay } from '@/api/hooks/auth/useLoginDisplay';
enum UserType {
  Real,
  Legal,
}
const LoginContainer = () => {
  const {
    hasSejam,
    setHasSejam
  } = useAuthStore();
  const [userType, setUserType] = useState<UserType>(UserType.Real);
  const {
    isPending
  } = useLoginDisplay();
  const backToLoginPage = () => {
    setHasSejam(true);
  };
  useEffect(() => {
    setHasSejam(true);
    sendGoogleGTMEvent({
      event: 'log_reg_view'
    });
  }, []);
  if (isPending) return null;
  return hasSejam ? <>
      <LogoHeader />
      <AuthContainer>
        {userType === UserType.Real ? <>
            <LoginContainerFactory />
            <Button onClick={() => setUserType(UserType.Legal)} color='primary' startIcon={<BusinessRoundedIcon />} fullWidth>
              کاربر حقوقی هستم
            </Button>
          </> : <>
            <NationalIdFrom />
            <Button onClick={() => setUserType(UserType.Real)} color='primary' fullWidth startIcon={<AccountCircleOutlinedIcon />}>
              کاربر حقیقی هستم
            </Button>
          </>}
      </AuthContainer>
    </> : <NoSejamInfo back={backToLoginPage} />;
};
export default LoginContainer;